import { useState, useEffect } from 'react';
import { ReferralStatus, ReferralStatusType } from 'global/referralStatus';
import { Services } from 'services';
import { ReferralDto } from 'common/api';
import { useIntl } from 'react-intl';
import { Box, Button, Text, TextField } from '@clariness/clarikit-react';

type Props = {
  referral?: ReferralDto;
};

export const SponsorID = ({ referral }: Props) => {
  const intl = useIntl();
  const [sponsorPatientID, setSponsorPatientID] = useState<string>();
  const [isSponsorPatientIDEditable, setIsSponsorPatientIDEditable] =
    useState<boolean>(true);
  const isDisbaled =
    ReferralStatus[referral?.status as ReferralStatusType] !==
      ReferralStatus.CONSENTED &&
    ReferralStatus[referral?.status as ReferralStatusType] !==
      ReferralStatus.SCREENING_FAILURE &&
    ReferralStatus[referral?.status as ReferralStatusType] !==
      ReferralStatus.RANDOMIZED;

  const { updateReferralSponsorPatientIdAPI } =
    Services.Referrals.useUpdateReferralSponsorPatientId();

  useEffect(() => {
    setSponsorPatientID(referral?.sponsorPatientID);
    if (referral?.sponsorPatientID) {
      setIsSponsorPatientIDEditable(false);
    }
  }, [referral]);

  const saveSponsorPatientID = () => {
    if (referral?.id && sponsorPatientID !== referral.sponsorPatientID) {
      updateReferralSponsorPatientIdAPI({
        referralId: referral.id,
        sponsorPatientID: sponsorPatientID || '',
      });
    }
    setIsSponsorPatientIDEditable(false);
  };

  const disableCheck = () => {
    if (isDisbaled) {
      return true;
    }
    return !isSponsorPatientIDEditable;
  };

  if (referral?.study?.hideSponsorPatientId) {
    return null;
  }

  return (
    <Box display="flex" flexWrap="wrap" gap="40" width="100%">
      <Box as="dt" style={{ flex: '0 0 150px' }}>
        <Text as="span" variant="bodyMd" fontWeight="bold">
          {intl.formatMessage({
            id: 'is.patient_details_modal.basic_details.sponsor_patient_id',
            defaultMessage: 'Sponsor Patient ID',
          })}
        </Text>
      </Box>
      <Box
        as="dd"
        margin="0"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
      >
        <TextField
          value={sponsorPatientID}
          disabled={disableCheck()}
          onChange={(val) => setSponsorPatientID(val)}
          autoComplete="off"
          label=""
        />
        {referral?.sponsorPatientID && !isSponsorPatientIDEditable ? (
          <Button
            variant="tertiary"
            size="m"
            onClick={() => setIsSponsorPatientIDEditable(true)}
            disabled={isDisbaled}
          >
            {intl.formatMessage({ id: 'is.edit', defaultMessage: 'Edit' })}
          </Button>
        ) : (
          <Button
            variant="tertiary"
            size="m"
            disabled={isDisbaled}
            onClick={saveSponsorPatientID}
          >
            {intl.formatMessage({ id: 'is.add', defaultMessage: 'Add' })}
          </Button>
        )}
      </Box>
    </Box>
  );
};
